import React from 'react';
import { MaterialIcon } from './MaterialIcon';

// Mapea los slugs de ícono que trae el backend (seed de categorías) a Material Symbols,
// calcando OBROS_CATEGORIES de tokens.jsx del proyecto de diseño.
const iconMap: Record<string, string> = {
  hammer: 'construction',
  zap: 'bolt',
  droplet: 'plumbing',
  paintbrush: 'format_paint',
  axe: 'handyman',
  flame: 'local_fire_department',
  'flower-2': 'yard',
  home: 'home_repair_service',
  snowflake: 'ac_unit',
  wrench: 'build',
  gem: 'diamond',
  square: 'dashboard',
};

interface CategoryIconProps {
  name?: string;
  size?: number;
  className?: string;
}

export const CategoryIcon: React.FC<CategoryIconProps> = ({ name, size = 24, className = '' }) => {
  if (!name) return null;
  const icon = iconMap[name.toLowerCase()] || 'work';
  return <MaterialIcon name={icon} size={size} className={className} />;
};
